/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgHierarchyTwoBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9992 6.60001C11.5218 6.60001 11.064 6.41036 10.7264 6.0728C10.3889 5.73523 10.1992 5.27739 10.1992 4.8C10.1992 4.32261 10.3889 3.86477 10.7264 3.52721C11.064 3.18964 11.5218 3 11.9992 3C12.4766 3 12.9344 3.18964 13.272 3.52721C13.6096 3.86477 13.7992 4.32261 13.7992 4.8C13.7992 5.27739 13.6096 5.73523 13.272 6.0728C12.9344 6.41036 12.4766 6.60001 11.9992 6.60001ZM11.9992 6.60001V17.4M11.9992 17.4C12.4766 17.4 12.9344 17.5897 13.272 17.9272C13.6096 18.2648 13.7992 18.7226 13.7992 19.2C13.7992 19.6774 13.6096 20.1353 13.272 20.4728C12.9344 20.8104 12.4766 21 11.9992 21C11.5218 21 11.064 20.8104 10.7264 20.4728C10.3889 20.1353 10.1992 19.6774 10.1992 19.2C10.1992 18.7226 10.3889 18.2648 10.7264 17.9272C11.064 17.5897 11.5218 17.4 11.9992 17.4ZM5.39844 17.4C5.39844 16.1269 5.90415 14.906 6.80433 14.0059C7.7045 13.1057 8.9254 12.6 10.1984 12.6H13.7984C15.0715 12.6 16.2924 13.1057 17.1926 14.0059C18.0927 14.906 18.5985 16.1269 18.5985 17.4M3.59961 19.2C3.59961 19.6774 3.78925 20.1353 4.12682 20.4728C4.46438 20.8104 4.92222 21 5.39961 21C5.877 21 6.33484 20.8104 6.67241 20.4728C7.00997 20.1353 7.19961 19.6774 7.19961 19.2C7.19961 18.7226 7.00997 18.2648 6.67241 17.9272C6.33484 17.5897 5.877 17.4 5.39961 17.4C4.92222 17.4 4.46438 17.5897 4.12682 17.9272C3.78925 18.2648 3.59961 18.7226 3.59961 19.2ZM16.8008 19.2C16.8008 19.6774 16.9904 20.1353 17.328 20.4728C17.6656 20.8104 18.1234 21 18.6008 21C19.0782 21 19.536 20.8104 19.8736 20.4728C20.2111 20.1353 20.4008 19.6774 20.4008 19.2C20.4008 18.7226 20.2111 18.2648 19.8736 17.9272C19.536 17.5897 19.0782 17.4 18.6008 17.4C18.1234 17.4 17.6656 17.5897 17.328 17.9272C16.9904 18.2648 16.8008 18.7226 16.8008 19.2Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgHierarchyTwo = wrapIcon(SvgHierarchyTwoBase);
export default SvgHierarchyTwo;
